import { useState } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/signInPreview.module.css";
import AuthGlassShell, { CardHead, Icon, MailIcon } from "./AuthGlassShell";

const SHOPIFY_APP = "https://apps.shopify.com/u-send";

// Login in the client preview.
export default function SignInPreview({ values, onChange, onSubmit }) {
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const ready = values.email.trim() !== "" && values.password !== "";

  const submit = async (e) => {
    e.preventDefault();
    if (!ready || busy) return;
    setBusy(true);
    try {
      await onSubmit();
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthGlassShell>
        <form className={styles.card} onSubmit={submit} noValidate>
          <CardHead title="Log in to U-Send" text="Your orders, products and wallet, all in one place." />

          <label className={styles.field}>
            <span className={styles.srOnly}>Email</span>
            <MailIcon />
            <input
              type="email"
              name="email"
              inputMode="email"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck="false"
              placeholder="Email"
              value={values.email}
              onChange={onChange}
              required
            />
          </label>

          <label className={styles.field}>
            <span className={styles.srOnly}>Password</span>
            <Icon>
              <rect x="5" y="11" width="14" height="10" rx="2" />
              <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </Icon>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              autoComplete="current-password"
              placeholder="Password"
              value={values.password}
              onChange={onChange}
              required
            />
            <button
              type="button"
              className={styles.reveal}
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              aria-pressed={showPassword}
            >
              {showPassword ? (
                <Icon>
                  <path d="M2.5 12S6 5 12 5s9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7Z" />
                  <circle cx="12" cy="12" r="3" />
                </Icon>
              ) : (
                <Icon>
                  <path d="M3 3l18 18" />
                  <path d="M10.6 5.1A10.4 10.4 0 0 1 12 5c6 0 9.5 7 9.5 7a17.6 17.6 0 0 1-3 3.8M6.6 6.6A17.4 17.4 0 0 0 2.5 12S6 19 12 19a9.8 9.8 0 0 0 5.4-1.6" />
                  <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
                </Icon>
              )}
            </button>
          </label>

          <Link to="/forgot-password" className={styles.forgot}>
            Forgot password?
          </Link>

          <button type="submit" className={styles.primary} disabled={!ready || busy}>
            {busy ? "Logging in…" : "Log in"}
          </button>

          <div className={styles.or}>
            <span>New to U-Send?</span>
          </div>

          <a className={styles.secondary} href={SHOPIFY_APP}>
            <img src="https://u-send.s3.eu-west-2.amazonaws.com/shopify-logo.png" alt="" />
            Install U-Send on Shopify
          </a>
        </form>
    </AuthGlassShell>
  );
}
